const icons = {
  corsac: "token-icons/corsac.png",
  bnbIcon: "token-icons/bnb.png",
  corsacBNBLPIcon: "token-icons/corsacBNB.png",
};

module.exports = icons;
